import { useMemo } from 'react';
import { filterPlaysForViewer } from '../core/rules/playsAccess';
import { useData } from '../contexts/index';
import { useDataSync } from './useDataSync';

import type { AppUser } from '../types';
import type { PlayLike } from '../core/rules/numberCaps';

export function usePlaysForViewer(viewer: AppUser | { id?: string; role?: string } | null | undefined) {
  const { adapter } = useData();
  const allPlays = useDataSync<PlayLike[]>(adapter, 'plays', []);
  return useMemo(
    () => filterPlaysForViewer(allPlays, viewer),
    [allPlays, viewer?.id, viewer?.role],
  );
}
